import { combineReducers } from 'redux';

//import server from './serverReducer';
import unsavedFence from './unsavedFenceReducer';
import server from './serverReducers';
//import filters from './filterReducer';

const poiReducers = combineReducers({
	unsavedFence,
	server,
});

export default poiReducers;


// WEBPACK FOOTER //
// ./src/pois/reducer.js